import React from 'react';
import classnames from 'classnames';
import partial from 'lodash/partial';
import {FormattedMessage} from 'react-intl';
import {arrayOf, object, func, string, bool} from 'prop-types';
import {Grid, List, Label, Button, Icon} from 'semantic-ui-react';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import DynamicContentRule from './DynamicContentRule';

const DynamicContentRules = props => (
  <div>
    <Grid className={classnames('dynamic-content-rules', props.className)}>
      <Grid.Row>
        <Label basic className='db-field-label'>
          {props.required && <Icon className='asterisk icon inline' />}
          <FormattedMessage id={props.labelKey} />
        </Label>
      </Grid.Row>
      <Grid.Row>
        <List>
          {(props.resource.dynamics || []).map((rule, index) => (
            <DynamicContentRule
                key={rule.id}
              rule={rule}
              {...props.saveStatuses[index]}
              onResultChange={partial(props.onResultChange, index)}
              onActionChange={partial(props.onActionChange, index)}
              onRemove={partial(props.onRemoveRule, index)}
              resourceType={props.resource.resourceId.type}
              results={props.resource.supportedOptions}
              actions={props.resource.supportedDynamicActions} />
          ))}
        </List>
      </Grid.Row>
    </Grid>
    <Button
      primary
      onClick={props.onAddRule}
      loading={props.newRuleStatus.isSaving}
      disabled={props.newRuleStatus.isSaving}>
      <Icon name='plus' />
      <FormattedMessage id='add' />
    </Button>
  </div>
);

DynamicContentRules.propTypes = {
  onAddRule: func.isRequired,
  onRemoveRule: func.isRequired,
  onValueChanged: func.isRequired,
  saveStatuses: arrayOf(object),
  newRuleStatus: object,
  resource: object,
  required: bool,
  labelKey: string
};

DynamicContentRules.defaultProps = {
  // statuses of auto-saved rule edits
  saveStatuses: [],

  // auto-save status of newly-created rule
  newRuleStatus: {},

  resource: {}
};

export default DynamicContentRules;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/DynamicContentRules/DynamicContentRules.jsx